const projects = [
  /* ================================================================
     AI / MACHINE LEARNING  ·  Existing projects
     ================================================================ */
  {
    id: "ai-resume-screening",
    title: "AI Resume Screening & Job Recommendation",
    category: "AI / Machine Learning",
    domain: "HR Tech",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: 2999,
    shortDescription:
      "An AI-powered system that analyzes resumes, extracts candidate skills and recommends suitable job roles.",
    description:
      "Build an intelligent resume screening platform that uses Natural Language Processing and Machine Learning techniques to analyze resumes, identify skills, calculate candidate-job matching scores and recommend suitable job opportunities.",
    technologies: ["Python", "Pandas", "NumPy", "Scikit-learn", "NLP", "React", "Node.js", "MongoDB"],
    skills: ["Natural Language Processing", "Text Classification", "Feature Extraction", "Machine Learning", "Recommendation Systems", "REST API Development"],
    features: ["Resume upload", "Resume text extraction", "Skill extraction", "Candidate scoring", "Job recommendation", "Admin dashboard", "Candidate management", "Report generation"],
    suitableFor: ["BCA", "MCA", "B.Tech", "BE", "BSc Computer Science", "MSc Computer Science"],
  },
  {
    id: "student-placement-prediction",
    title: "Student Placement Prediction System",
    category: "Machine Learning",
    domain: "Education",
    difficulty: "Intermediate",
    duration: "6-8 Weeks",
    price: 2499,
    shortDescription:
      "Predict whether a student is likely to get placed based on academic and skill-related information.",
    description:
      "Develop a Machine Learning model that analyzes student academic performance, technical skills, communication skills, internships and other factors to predict placement probability.",
    technologies: ["Python", "Pandas", "NumPy", "Scikit-learn", "Matplotlib", "React", "Node.js", "MongoDB"],
    skills: ["Data Preprocessing", "Classification", "Feature Engineering", "Model Evaluation", "Data Visualization", "Machine Learning"],
    features: ["Student registration", "Student profile", "Placement prediction", "Probability score", "Performance analysis", "Admin dashboard", "Prediction history", "Reports"],
    suitableFor: ["BCA", "MCA", "B.Tech", "BE", "BSc CS"],
  },
  {
    id: "insurance-fraud-detection",
    title: "Insurance Claim Fraud Detection",
    category: "Machine Learning",
    domain: "Insurance",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: 3499,
    shortDescription:
      "Detect potentially fraudulent insurance claims using Machine Learning algorithms.",
    description:
      "Build an intelligent insurance fraud detection system that analyzes customer, policy and claim information to identify suspicious claims and classify them as potentially fraudulent or legitimate.",
    technologies: ["Python", "Pandas", "NumPy", "Scikit-learn", "Machine Learning", "React", "Node.js", "MongoDB"],
    skills: ["Fraud Detection", "Classification", "Data Cleaning", "Feature Engineering", "Model Training", "Model Evaluation"],
    features: ["Customer management", "Policy management", "Claim registration", "Fraud probability", "Claim risk score", "Fraud analysis dashboard", "Prediction reports", "Admin panel"],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS", "BCA"],
  },
  {
    id: "loan-approval-prediction",
    title: "Loan Approval Prediction System",
    category: "Machine Learning",
    domain: "Finance",
    difficulty: "Intermediate",
    duration: "6-8 Weeks",
    price: 2499,
    shortDescription:
      "Predict loan approval based on applicant financial and personal information.",
    description:
      "Develop a Machine Learning based loan prediction system that analyzes applicant income, credit history, employment and financial information to predict loan approval.",
    technologies: ["Python", "Pandas", "NumPy", "Scikit-learn", "Matplotlib", "React", "Node.js", "MongoDB"],
    skills: ["Classification", "Data Preprocessing", "Feature Engineering", "Model Evaluation", "Predictive Analytics"],
    features: ["Applicant registration", "Loan application", "Loan prediction", "Approval probability", "Applicant history", "Admin dashboard", "Reports"],
    suitableFor: ["BCA", "MCA", "B.Tech", "BE"],
  },
  {
    id: "customer-churn-prediction",
    title: "Customer Churn Prediction",
    category: "Machine Learning",
    domain: "Business Analytics",
    difficulty: "Intermediate",
    duration: "6-8 Weeks",
    price: 2499,
    shortDescription:
      "Predict customers who are likely to stop using a company's services.",
    description:
      "Create a predictive analytics system that analyzes customer behavior, usage patterns and service history to identify customers who are at risk of leaving.",
    technologies: ["Python", "Pandas", "NumPy", "Scikit-learn", "Matplotlib", "React", "Node.js", "MongoDB"],
    skills: ["Classification", "Customer Analytics", "Data Visualization", "Feature Engineering", "Predictive Modeling"],
    features: ["Customer management", "Customer data analysis", "Churn prediction", "Risk score", "Customer segmentation", "Analytics dashboard", "Reports"],
    suitableFor: ["BCA", "MCA", "B.Tech", "BE", "MSc CS"],
  },
  {
    id: "real-estate-price-prediction",
    title: "Real Estate Price Prediction",
    category: "Machine Learning",
    domain: "Real Estate",
    difficulty: "Intermediate",
    duration: "6-8 Weeks",
    price: 2499,
    shortDescription:
      "Predict property prices using location, size, rooms and other property attributes.",
    description:
      "Develop a Machine Learning model that predicts real estate prices based on property characteristics such as location, area, number of rooms, amenities and other relevant attributes.",
    technologies: ["Python", "Pandas", "NumPy", "Scikit-learn", "Matplotlib", "React", "Node.js", "MongoDB"],
    skills: ["Regression", "Data Analysis", "Feature Engineering", "Data Visualization", "Predictive Analytics"],
    features: ["Property registration", "Price prediction", "Property search", "Prediction history", "Property analytics", "Admin dashboard"],
    suitableFor: ["BCA", "MCA", "B.Tech", "BE"],
  },
  {
    id: "sales-forecasting",
    title: "AI Sales Forecasting System",
    category: "Machine Learning",
    domain: "Business Analytics",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: 3499,
    shortDescription:
      "Forecast future sales using historical sales data and Machine Learning techniques.",
    description:
      "Build an intelligent sales forecasting system that analyzes historical sales data, seasonal trends and product performance to generate future sales predictions.",
    technologies: ["Python", "Pandas", "NumPy", "Scikit-learn", "Matplotlib", "React", "Node.js", "MongoDB"],
    skills: ["Regression", "Time Series Analysis", "Data Visualization", "Forecasting", "Predictive Analytics"],
    features: ["Sales data management", "Product analytics", "Sales forecasting", "Interactive charts", "Performance dashboard", "Forecast reports"],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },
  {
    id: "student-performance-prediction",
    title: "Student Performance Prediction",
    category: "Machine Learning",
    domain: "Education",
    difficulty: "Beginner",
    duration: "5-6 Weeks",
    price: 1999,
    shortDescription:
      "Predict student academic performance using attendance, marks and other academic factors.",
    description:
      "Create a Machine Learning based student performance prediction system that analyzes attendance, previous marks, assignments and other factors to predict academic performance.",
    technologies: ["Python", "Pandas", "NumPy", "Scikit-learn", "Matplotlib", "React", "Node.js", "MongoDB"],
    skills: ["Data Preprocessing", "Regression", "Classification", "Data Visualization", "Machine Learning"],
    features: ["Student registration", "Academic data", "Performance prediction", "Risk identification", "Performance dashboard", "Reports"],
    suitableFor: ["BCA", "MCA", "BSc CS"],
  },
  {
    id: "healthcare-disease-prediction",
    title: "Healthcare Disease Prediction",
    category: "Machine Learning",
    domain: "Healthcare",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: 3499,
    shortDescription:
      "Predict possible diseases from user-provided symptoms using Machine Learning.",
    description:
      "Develop an educational Machine Learning project that analyzes symptom-related input and predicts possible disease categories using a trained classification model.",
    technologies: ["Python", "Pandas", "NumPy", "Scikit-learn", "Machine Learning", "React", "Node.js", "MongoDB"],
    skills: ["Classification", "Data Preprocessing", "Feature Selection", "Model Evaluation", "Machine Learning"],
    features: ["User registration", "Symptom input", "Prediction system", "Prediction history", "Analytics dashboard", "Admin panel"],
    suitableFor: ["BCA", "MCA", "B.Tech", "BE", "MSc CS"],
  },
  {
    id: "recommendation-system",
    title: "AI Recommendation System",
    category: "Artificial Intelligence",
    domain: "Recommendation",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: 3499,
    shortDescription:
      "Build an intelligent recommendation engine that suggests relevant products or content to users.",
    description:
      "Develop a recommendation system using user preferences, historical interactions and item characteristics to generate personalized recommendations.",
    technologies: ["Python", "Pandas", "NumPy", "Scikit-learn", "Machine Learning", "React", "Node.js", "MongoDB"],
    skills: ["Recommendation Systems", "Machine Learning", "Similarity Algorithms", "Data Processing", "Personalization"],
    features: ["User registration", "User preferences", "Recommendation engine", "Personalized recommendations", "Rating system", "Analytics dashboard", "Admin panel"],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },

  /* ================================================================
     FULL STACK DEVELOPMENT  ·  20 projects
     ================================================================ */
  {
    id: "ecommerce-web-application",
    title: "E-Commerce Web Application",
    category: "Full Stack",
    domain: "Retail & E-Commerce",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: 3999,
    shortDescription:
      "A complete online store with product catalog, cart, checkout, order tracking and an admin panel.",
    description:
      "Build a production-ready e-commerce platform with a customer storefront, cart and checkout flow, order tracking, and a full admin dashboard for managing products, categories and orders.",
    technologies: ["React", "Redux", "Node.js", "Express.js", "MySQL", "Stripe / Razorpay"],
    skills: ["Schema Design", "Wireframing", "React & Redux", "REST API Development", "Payment Gateway Integration", "Deployment"],
    features: ["Product catalog", "Shopping cart & checkout", "Order tracking", "Admin dashboard", "Payment integration", "Order history"],
    suitableFor: ["BCA", "MCA", "B.Tech", "BE", "MSc CS"],
  },
  {
    id: "food-delivery-application",
    title: "Food Delivery Application",
    category: "Full Stack",
    domain: "Food Delivery",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: 3999,
    shortDescription:
      "A food ordering platform with restaurant listings, menus, cart and live order tracking.",
    description:
      "Develop a full food delivery system with a customer app for browsing restaurants and placing orders, plus restaurant and delivery-agent dashboards, with real-time order status updates via WebSockets.",
    technologies: ["React", "React Native", "Node.js", "Express.js", "MongoDB Atlas", "Socket.IO"],
    skills: ["Real-Time Architecture", "WebSocket Communication", "Geolocation Search", "Schema Design", "Push Notifications", "Deployment"],
    features: ["Restaurant listings", "Menu browsing", "Cart & checkout", "Live order tracking", "Restaurant dashboard", "Delivery agent panel"],
    suitableFor: ["BCA", "MCA", "B.Tech", "BE", "MSc CS"],
  },
  {
    id: "realtime-chat-messaging-app",
    title: "Real-Time Chat and Messaging Application",
    category: "Full Stack",
    domain: "Communication",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: 3999,
    shortDescription:
      "One-to-one and group chat with media sharing, online status, typing indicators and read receipts.",
    description:
      "Build a real-time messaging platform supporting private and group conversations, media sharing and presence tracking — with read receipts and typing indicators powered by Socket.IO.",
    technologies: ["React", "Node.js", "Express.js", "Socket.IO", "MongoDB", "Redis"],
    skills: ["Real-Time Architecture", "Socket.IO", "Presence Tracking", "Schema Design", "Concurrency Handling", "Deployment"],
    features: ["One-to-one chat", "Group chat", "Media sharing", "Online status", "Typing indicators", "Read receipts"],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },
  {
    id: "job-portal-recruitment-platform",
    title: "Job Portal and Recruitment Platform",
    category: "Full Stack",
    domain: "Career Technology",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: 3999,
    shortDescription:
      "A recruitment platform with job listings, resume uploads, application tracking and an employer dashboard.",
    description:
      "Build a full recruitment platform where employers post jobs, candidates apply with resumes, and applications flow through a tracked status pipeline — with full-text search across jobs and profiles.",
    technologies: ["React", "Node.js", "Express.js", "MongoDB Atlas", "Elasticsearch", "AWS S3"],
    skills: ["Full-Text Search", "File Uploads", "Schema Design", "Application Workflow", "Resume Parsing", "Deployment"],
    features: ["Job listings & search", "Resume upload", "Application tracking", "Employer dashboard", "Candidate profiles", "Filters & search relevance"],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },
  {
    id: "recipe-sharing-meal-planning",
    title: "Recipe Sharing and Meal Planning Platform",
    category: "Full Stack",
    domain: "Food & Lifestyle",
    difficulty: "Intermediate",
    duration: "6-8 Weeks",
    price: 2999,
    shortDescription:
      "Share recipes, search by ingredient and plan weekly meals with ratings and reviews.",
    description:
      "Create a recipe community platform where users upload recipes, search by ingredients, build meal plans and rate each other's dishes — with full-text ingredient search.",
    technologies: ["React", "Node.js", "Express.js", "PostgreSQL", "Cloudinary", "Bootstrap"],
    skills: ["Full-Text Search", "Schema Design", "Image Uploads", "Rating Aggregation", "React Development", "Deployment"],
    features: ["Recipe upload", "Ingredient search", "Meal planner", "Ratings & reviews", "Image storage", "User profiles"],
    suitableFor: ["BCA", "MCA", "B.Tech", "BE"],
  },
  {
    id: "fitness-workout-tracking",
    title: "Fitness and Workout Tracking Application",
    category: "Full Stack",
    domain: "Health & Fitness",
    difficulty: "Intermediate",
    duration: "6-8 Weeks",
    price: 2999,
    shortDescription:
      "Log workouts, track progress with charts, set goals and follow structured workout plans.",
    description:
      "Develop a fitness tracker where users log workouts, view progress charts, set and track goals, and follow structured plans — built as a PWA for a mobile-like experience.",
    technologies: ["React", "Recharts", "Node.js", "Express.js", "MongoDB", "PWA"],
    skills: ["Data Visualization", "Schema Design", "Progress Calculations", "PWA Setup", "React Development", "Deployment"],
    features: ["Workout logging", "Progress charts", "Goal setting & tracking", "Workout plans", "Dashboard with charts", "PWA support"],
    suitableFor: ["BCA", "MCA", "B.Tech", "BE"],
  },
  {
    id: "expense-budget-tracker",
    title: "Personal Expense and Budget Tracker",
    category: "Full Stack",
    domain: "Personal Finance",
    difficulty: "Intermediate",
    duration: "6-8 Weeks",
    price: 2999,
    shortDescription:
      "Track expenses, categorize spending, set budgets and view monthly reports with graphs.",
    description:
      "Build a personal finance tracker with expense entry, categorization, monthly budgets, alerts on thresholds and downloadable reports with visual charts.",
    technologies: ["React", "Chart.js", "Node.js", "Express.js", "PostgreSQL", "Nodemailer"],
    skills: ["Data Visualization", "Schema Design", "Scheduled Jobs", "Report Generation", "React Development", "Deployment"],
    features: ["Expense entry", "Category management", "Budget limits & alerts", "Monthly reports", "Charts & analytics", "Email report schedule"],
    suitableFor: ["BCA", "MCA", "B.Tech", "BE"],
  },
  {
    id: "event-booking-ticketing",
    title: "Event Booking and Ticketing Platform",
    category: "Full Stack",
    domain: "Events",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: 3999,
    shortDescription:
      "List events, sell tickets with seat selection, handle payments and refunds.",
    description:
      "Build a full event ticketing system with event listings, seat selection, concurrent-safe booking, payment gateway integration and a refund workflow.",
    technologies: ["React", "Node.js", "Express.js", "MySQL", "Stripe / Razorpay", "Webhooks"],
    skills: ["Seat Locking", "Concurrency Handling", "Payment Gateway Integration", "Webhook Handling", "Schema Design", "Deployment"],
    features: ["Event listings", "Seat selection UI", "Concurrent-safe booking", "Payment & refunds", "Webhook handling", "Booking history"],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },
  {
    id: "portfolio-resume-builder",
    title: "Portfolio and Resume Builder Platform",
    category: "Full Stack",
    domain: "Career Technology",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: 3999,
    shortDescription:
      "Drag-and-drop portfolio builder with templates, live preview and PDF export.",
    description:
      "Create a portfolio builder where users drag-and-drop sections into templates, preview their portfolio live, publish to a custom subdomain and export a PDF resume.",
    technologies: ["React", "Node.js", "Express.js", "MongoDB", "Puppeteer", "Vercel"],
    skills: ["Drag-and-Drop UI", "PDF Generation", "Auto-Save Logic", "Subdomain Hosting", "React Development", "Deployment"],
    features: ["Drag-and-drop editor", "Templates", "Live preview", "PDF export", "Auto-save", "Custom subdomain hosting"],
    suitableFor: ["BCA", "MCA", "B.Tech", "BE"],
  },
  {
    id: "url-shortener-analytics",
    title: "URL Shortener and Link Analytics Platform",
    category: "Full Stack",
    domain: "Developer Tools",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: 3999,
    shortDescription:
      "Shorten URLs, use custom aliases, track clicks with analytics and generate QR codes.",
    description:
      "Develop a URL shortener service with custom aliases, QR code generation and a full analytics dashboard tracking clicks, geography and device types behind a Redis-cached redirect layer.",
    technologies: ["React", "Node.js", "Express.js", "Redis", "MongoDB", "CDN"],
    skills: ["Redis Caching", "Redirect Architecture", "Analytics Tracking", "Alias Collision Handling", "QR Code Generation", "Deployment"],
    features: ["URL shortening", "Custom aliases", "Click analytics", "QR code generation", "Geographic tracking", "Fast redirects"],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },
  {
    id: "weather-forecast-alert-dashboard",
    title: "Weather Forecast and Alert Dashboard",
    category: "Full Stack",
    domain: "Utilities",
    difficulty: "Intermediate",
    duration: "6-8 Weeks",
    price: 2999,
    shortDescription:
      "Location-based weather forecast with alerts, historical trends, charts and maps.",
    description:
      "Build a weather dashboard where users save locations, view forecasts and historical trends on charts and maps, and receive alerts when thresholds are crossed.",
    technologies: ["React", "Chart.js", "Node.js", "Express.js", "Weather API", "MongoDB"],
    skills: ["Third-Party API Integration", "API Caching", "Alert Thresholds", "Data Visualization", "Scheduled Jobs", "Deployment"],
    features: ["Location-based forecasts", "Weather alerts", "Historical trends", "Charts & maps", "Saved locations", "Scheduled alert notifications"],
    suitableFor: ["BCA", "MCA", "B.Tech", "BE"],
  },
  {
    id: "movie-tv-recommendation",
    title: "Movie and TV Show Recommendation Platform",
    category: "Full Stack",
    domain: "Entertainment",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: 3499,
    shortDescription:
      "Browse movies, rate titles, maintain watchlists and get personalized recommendations.",
    description:
      "Build a movie discovery platform with ratings, watchlists and a collaborative-filtering recommendation engine, backed by a public movie database API with server-side caching.",
    technologies: ["React", "Node.js", "Express.js", "MongoDB", "TMDB API", "Recommendation Engine"],
    skills: ["Collaborative Filtering", "API Caching", "Rating Aggregation", "Schema Design", "React Development", "Deployment"],
    features: ["Movie & TV browsing", "Ratings", "Watchlists", "Personalized recommendations", "API response caching", "User profiles"],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },
  {
    id: "music-streaming-playlist",
    title: "Music Streaming and Playlist Platform",
    category: "Full Stack",
    domain: "Entertainment",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: 3999,
    shortDescription:
      "Stream music, build playlists, reorder tracks and persist playback state across sessions.",
    description:
      "Develop a music streaming platform with an in-browser audio player, playlist management, likes and CDN-backed audio delivery for smooth streaming.",
    technologies: ["React", "Node.js", "Express.js", "MongoDB", "AWS S3", "CloudFront"],
    skills: ["Audio Streaming Architecture", "CDN Delivery", "Playback State Management", "Playlist Management", "React Development", "Deployment"],
    features: ["Song browsing", "Playlist creation", "Audio streaming", "Likes & favorites", "Playback persistence", "Artist pages"],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },
  {
    id: "hotel-booking-reservation",
    title: "Hotel Booking and Reservation Web Application",
    category: "Full Stack",
    domain: "Hospitality",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: 3999,
    shortDescription:
      "Search rooms, check availability, book with payment and handle cancellations with refunds.",
    description:
      "Build a hotel reservation system with room search, availability calendar, booking with availability locking to prevent double-booking, payment integration and a full refund flow.",
    technologies: ["React", "Node.js", "Express.js", "MySQL", "Stripe / Razorpay", "Redis"],
    skills: ["Availability Locking", "Date-Range Logic", "Caching Search Results", "Payment Integration", "Refund Workflow", "Deployment"],
    features: ["Room search", "Availability calendar", "Prevent double-booking", "Payment integration", "Cancellation & refund", "Booking history"],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },
  {
    id: "healthcare-appointment-system",
    title: "Healthcare Appointment Booking System",
    category: "Full Stack",
    domain: "Healthcare",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: 3999,
    shortDescription:
      "Book doctor appointments, run video consultations and store digital prescriptions securely.",
    description:
      "Develop a healthcare platform where patients search doctors, book appointments without slot conflicts, join video consultations via WebRTC and receive digital prescriptions — with encryption for sensitive data.",
    technologies: ["React", "Node.js", "Express.js", "MySQL", "WebRTC", "AWS"],
    skills: ["WebRTC Integration", "Slot Conflict Prevention", "Data Encryption", "Schema Design", "Secure Deployment", "API Development"],
    features: ["Doctor search", "Appointment booking", "Video consultation", "Digital prescriptions", "Slot conflict prevention", "Encrypted patient records"],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },
  {
    id: "pet-adoption-rescue",
    title: "Pet Adoption and Rescue Platform",
    category: "Full Stack",
    domain: "Social Impact",
    difficulty: "Intermediate",
    duration: "6-8 Weeks",
    price: 2999,
    shortDescription:
      "List pets for adoption, manage shelters and process adoption applications end-to-end.",
    description:
      "Create a pet adoption platform where shelters list animals, users browse and filter by pet type and location, and applications flow through a tracked approval workflow with email notifications.",
    technologies: ["React", "Node.js", "Express.js", "PostgreSQL", "Cloudinary", "Nodemailer"],
    skills: ["Image Uploads", "Search & Filter", "Application Workflow", "Email Notifications", "Schema Design", "Deployment"],
    features: ["Pet listings", "Shelter management", "Adoption applications", "Search by type & location", "Image gallery", "Email notifications"],
    suitableFor: ["BCA", "MCA", "B.Tech", "BE"],
  },
  {
    id: "language-learning-web-app",
    title: "Language Learning Web Application",
    category: "Full Stack",
    domain: "Education",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: 3499,
    shortDescription:
      "Lessons, flashcards with spaced repetition, quizzes, streaks and progress tracking.",
    description:
      "Build a language learning platform with structured lessons, spaced-repetition flashcards, quizzes and a streak system — packaged as a PWA for offline lesson access.",
    technologies: ["React", "Node.js", "Express.js", "MongoDB", "PWA", "Service Workers"],
    skills: ["Spaced-Repetition Algorithm", "Streak Logic", "Quiz Scoring", "PWA & Offline Support", "React Development", "Deployment"],
    features: ["Structured lessons", "Flashcards", "Quizzes", "Progress tracking", "Daily streaks", "Offline lesson access"],
    suitableFor: ["BCA", "MCA", "B.Tech", "BE"],
  },
  {
    id: "news-aggregator-personalized-feed",
    title: "News Aggregator and Personalized Feed Platform",
    category: "Full Stack",
    domain: "Media",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: 3499,
    shortDescription:
      "Aggregate news from multiple sources, filter by category and get a personalized feed.",
    description:
      "Develop a news aggregator that pulls from multiple news APIs, deduplicates stories, caches responses and ranks a personalized feed based on user category preferences and bookmarks.",
    technologies: ["React", "Node.js", "Express.js", "MongoDB", "News APIs", "Redis"],
    skills: ["Feed-Ranking Algorithm", "Article Deduplication", "API Caching", "Scheduled Fetching", "React Development", "Deployment"],
    features: ["Multi-source aggregation", "Category filters", "Bookmarks", "Personalized feed", "Deduplication", "Periodic refresh"],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },
  {
    id: "digital-library-ebook-reader",
    title: "Digital Library and E-Book Reading Platform",
    category: "Full Stack",
    domain: "Education",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: 3999,
    shortDescription:
      "Browse an e-book catalog, read books in-browser and sync bookmarks and progress across devices.",
    description:
      "Build a digital library with an in-browser e-reader, EPUB support, bookmarks, reading progress that syncs across devices, and search across the catalog — with book files served from S3/CloudFront.",
    technologies: ["React", "epub.js", "Node.js", "Express.js", "MongoDB", "AWS S3 / CloudFront"],
    skills: ["E-Reader Integration", "Progress Sync", "Schema Design", "CDN Delivery", "React Development", "Deployment"],
    features: ["E-book catalog", "In-browser reader", "Bookmarks", "Reading progress sync", "Search & filter", "S3 storage"],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },
  {
    id: "online-auction-bidding",
    title: "Online Auction and Bidding Platform",
    category: "Full Stack",
    domain: "Marketplace",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: 3999,
    shortDescription:
      "List items, bid live with real-time updates, handle auction timers and capture payment on win.",
    description:
      "Build a live auction platform with WebSocket-driven bidding, automatic timer extension on late bids, race-condition-safe bid handling via Redis locks, and payment capture when an auction closes.",
    technologies: ["React", "Node.js", "Express.js", "MongoDB", "Socket.IO", "Redis"],
    skills: ["Real-Time Bidding", "Redis Locking", "Race Condition Handling", "Auto-Extend Timers", "Payment Integration", "Deployment"],
    features: ["Item listings", "Live bidding", "Auction timers", "Auto-extend on late bids", "Payment on win", "Bid history"],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },

  /* ================================================================
     COMPUTER VISION  ·  NEW
     ================================================================ */
  {
    id: "face-recognition-attendance",
    title: "Face Recognition Based Attendance System",
    category: "Computer Vision",
    domain: "Education",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: 3499,
    shortDescription:
      "Mark attendance automatically using real-time face detection and recognition.",
    description:
      "Build a computer vision attendance system that detects and recognizes registered faces from a webcam feed, marks attendance in real time and generates daily and monthly reports for administrators.",
    technologies: ["Python", "OpenCV", "face_recognition", "dlib", "Flask", "React", "MySQL"],
    skills: ["Face Detection", "Face Embeddings", "Real-Time Video Processing", "Recognition Pipeline", "REST API Development", "Database Design"],
    features: ["Student enrollment", "Face capture & training", "Live attendance marking", "Duplicate prevention", "Attendance dashboard", "Daily / monthly reports"],
    suitableFor: ["BCA", "MCA", "B.Tech", "BE", "MSc CS"],
  },
  {
    id: "object-detection-surveillance",
    title: "Object Detection for Smart Surveillance",
    category: "Computer Vision",
    domain: "Security",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: 3999,
    shortDescription:
      "Detect and track people, vehicles and suspicious objects in live CCTV feeds.",
    description:
      "Develop a YOLO-based surveillance system that processes live or recorded video, detects and tracks objects, raises alerts for intrusion or abandoned items and stores event logs with snapshots.",
    technologies: ["Python", "YOLOv8", "OpenCV", "PyTorch", "Flask", "React", "MongoDB"],
    skills: ["Object Detection", "Multi-Object Tracking", "Video Stream Processing", "Alert Logic", "Model Optimization", "REST API Development"],
    features: ["Live video ingestion", "Person / vehicle detection", "Object tracking", "Intrusion alerts", "Event snapshots", "Analytics dashboard"],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },
  {
    id: "anpr-license-plate-recognition",
    title: "Automatic Number Plate Recognition (ANPR)",
    category: "Computer Vision",
    domain: "Transport & Smart City",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: 3999,
    shortDescription:
      "Detect and read vehicle number plates from images or live camera feeds.",
    description:
      "Build an ANPR system that detects license plates using YOLO, extracts characters using OCR, logs vehicle entries with timestamps and supports search by plate number for parking or toll applications.",
    technologies: ["Python", "YOLOv8", "Tesseract OCR", "OpenCV", "Flask", "React", "MySQL"],
    skills: ["Plate Detection", "OCR Pipeline", "Image Preprocessing", "Real-Time Video Handling", "REST API Development", "Database Design"],
    features: ["Plate detection", "OCR extraction", "Vehicle entry logging", "Search by plate", "Snapshot storage", "Admin dashboard"],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },
  {
    id: "sign-language-recognition",
    title: "Sign Language Recognition System",
    category: "Computer Vision",
    domain: "Accessibility",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: 3999,
    shortDescription:
      "Recognize hand signs from a webcam and translate them into readable text in real time.",
    description:
      "Build a sign language recognition system using MediaPipe hand landmarks and a classifier that maps gestures to text, supporting common words and letters to help bridge communication with hearing-impaired users.",
    technologies: ["Python", "MediaPipe", "TensorFlow", "OpenCV", "Flask", "React"],
    skills: ["Hand Landmark Detection", "Sequence Modeling", "Gesture Classification", "Real-Time Inference", "Model Evaluation", "REST API Development"],
    features: ["Live gesture capture", "Hand landmark extraction", "Sign-to-text mapping", "Word suggestions", "History log", "Practice mode"],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },
  {
    id: "medical-image-classification",
    title: "Medical Image Classification with Deep Learning",
    category: "Computer Vision",
    domain: "Healthcare",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: 3999,
    shortDescription:
      "Classify medical images such as X-rays or scans using CNN transfer learning.",
    description:
      "Develop a CNN-based medical image classifier that uses transfer learning (ResNet/EfficientNet) to detect conditions from X-ray or scan datasets, with Grad-CAM visualisations and a simple review UI.",
    technologies: ["Python", "TensorFlow", "Keras", "OpenCV", "Flask", "React"],
    skills: ["Transfer Learning", "CNN Architecture", "Data Augmentation", "Model Evaluation", "Grad-CAM Visualisation", "REST API Development"],
    features: ["Dataset upload", "Preprocessing pipeline", "Model training", "Prediction with confidence", "Grad-CAM heatmaps", "Prediction history"],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },
  {
    id: "vehicle-counting-traffic-analysis",
    title: "Vehicle Counting and Traffic Analysis",
    category: "Computer Vision",
    domain: "Smart City",
    difficulty: "Intermediate",
    duration: "6-8 Weeks",
    price: 2999,
    shortDescription:
      "Count vehicles, estimate traffic density and analyse flow from camera feeds.",
    description:
      "Create a computer vision system that detects and counts vehicles crossing defined zones, estimates traffic density and produces hourly and daily traffic analytics for urban planning.",
    technologies: ["Python", "YOLOv8", "OpenCV", "Flask", "React", "MongoDB"],
    skills: ["Object Detection", "Region-of-Interest Logic", "Line-Crossing Counter", "Video Analytics", "Data Visualisation", "REST API Development"],
    features: ["Live vehicle detection", "Zone-based counting", "Direction tracking", "Hourly / daily reports", "Density heatmap", "Admin dashboard"],
    suitableFor: ["BCA", "MCA", "B.Tech", "BE"],
  },
  {
    id: "image-captioning-system",
    title: "AI Image Captioning System",
    category: "Computer Vision",
    domain: "Multimodal AI",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: 3999,
    shortDescription:
      "Generate natural-language captions for images using a CNN + LSTM encoder–decoder.",
    description:
      "Build an image captioning system that encodes images with a CNN and generates captions with an LSTM decoder, evaluated on BLEU scores and exposed through a simple web interface.",
    technologies: ["Python", "TensorFlow", "Keras", "OpenCV", "Flask", "React"],
    skills: ["Encoder–Decoder Models", "CNN Feature Extraction", "Sequence Generation", "BLEU Evaluation", "Model Deployment", "REST API Development"],
    features: ["Image upload", "Caption generation", "Top-k captions", "BLEU score display", "Caption history", "Admin dashboard"],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },
  {
    id: "document-scanner-ocr",
    title: "Smart Document Scanner with OCR",
    category: "Computer Vision",
    domain: "Productivity",
    difficulty: "Intermediate",
    duration: "6-8 Weeks",
    price: 2999,
    shortDescription:
      "Scan documents from phone photos, auto-crop, enhance and extract text with OCR.",
    description:
      "Build a document scanning tool that detects page edges, applies perspective correction, enhances contrast and runs OCR to extract editable text — with searchable PDF export.",
    technologies: ["Python", "OpenCV", "Tesseract OCR", "Flask", "React", "MongoDB"],
    skills: ["Edge Detection", "Perspective Transform", "Image Enhancement", "OCR Pipeline", "PDF Generation", "REST API Development"],
    features: ["Auto edge detection", "Perspective correction", "Contrast enhancement", "Text extraction", "Searchable PDF export", "Document history"],
    suitableFor: ["BCA", "MCA", "B.Tech", "BE"],
  },

  /* ================================================================
     DATA SCIENCE  ·  NEW
     ================================================================ */
  {
    id: "stock-market-analysis-prediction",
    title: "Stock Market Analysis and Price Prediction",
    category: "Data Science",
    domain: "Finance",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: 3499,
    shortDescription:
      "Analyse historical stock data and predict price trends using time-series models.",
    description:
      "Build a data science project that pulls historical stock data, computes technical indicators, visualises trends and applies ARIMA / LSTM models to forecast prices, with an interactive dashboard for exploration.",
    technologies: ["Python", "Pandas", "NumPy", "yfinance", "Plotly", "Streamlit"],
    skills: ["Time Series Analysis", "Technical Indicators", "ARIMA / LSTM", "Data Visualisation", "Statistical Analysis", "Dashboard Development"],
    features: ["Stock data fetch", "Technical indicator charts", "Trend forecasting", "Interactive dashboard", "Watchlist", "Prediction history"],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },
  {
    id: "covid19-data-analysis",
    title: "COVID-19 Data Analysis and Visualisation",
    category: "Data Science",
    domain: "Public Health",
    difficulty: "Intermediate",
    duration: "6-8 Weeks",
    price: 2499,
    shortDescription:
      "Analyse global COVID-19 data and visualise trends across countries and time.",
    description:
      "Develop a data analysis project that ingests global COVID-19 datasets, computes growth rates, vaccination coverage and fatality ratios, and presents interactive charts and maps.",
    technologies: ["Python", "Pandas", "Plotly", "Folium", "Streamlit", "CSV / API"],
    skills: ["Data Wrangling", "Time Series Visualisation", "Geospatial Analysis", "Statistical Comparison", "Dashboard Development", "Data Storytelling"],
    features: ["Multi-country analysis", "Growth rate charts", "Vaccination coverage", "Geospatial maps", "Filter by date range", "Exportable reports"],
    suitableFor: ["BCA", "MCA", "B.Tech", "BE"],
  },
  {
    id: "customer-segmentation-rfm",
    title: "Customer Segmentation using RFM Analysis",
    category: "Data Science",
    domain: "Business Analytics",
    difficulty: "Intermediate",
    duration: "6-8 Weeks",
    price: 2499,
    shortDescription:
      "Segment customers by Recency, Frequency and Monetary value using clustering.",
    description:
      "Build a customer segmentation system that computes RFM metrics, applies K-Means clustering and produces segment profiles with targeting recommendations for marketing teams.",
    technologies: ["Python", "Pandas", "Scikit-learn", "Matplotlib", "Seaborn", "Streamlit"],
    skills: ["RFM Analysis", "K-Means Clustering", "Feature Scaling", "Cluster Profiling", "Data Visualisation", "Dashboard Development"],
    features: ["Customer dataset upload", "RFM computation", "Elbow method", "Cluster visualisation", "Segment profiles", "Marketing recommendations"],
    suitableFor: ["BCA", "MCA", "B.Tech", "BE"],
  },
  {
    id: "sentiment-analysis-product-reviews",
    title: "Sentiment Analysis of Product Reviews",
    category: "Data Science",
    domain: "E-Commerce",
    difficulty: "Intermediate",
    duration: "6-8 Weeks",
    price: 2499,
    shortDescription:
      "Classify product reviews as positive, neutral or negative using NLP.",
    description:
      "Develop an NLP pipeline that cleans review text, extracts features with TF-IDF or embeddings and classifies sentiment using classical ML and transformer models, with an interactive dashboard.",
    technologies: ["Python", "Pandas", "Scikit-learn", "NLTK", "Transformers", "Streamlit"],
    skills: ["Text Preprocessing", "TF-IDF / Embeddings", "Sentiment Classification", "Model Evaluation", "Data Visualisation", "Dashboard Development"],
    features: ["Review upload", "Text cleaning", "Sentiment prediction", "Aspect-based breakdown", "Word clouds", "Accuracy & confusion matrix"],
    suitableFor: ["BCA", "MCA", "B.Tech", "BE"],
  },
  {
    id: "retail-sales-data-warehouse",
    title: "Retail Sales Data Warehouse & BI Dashboard",
    category: "Data Science",
    domain: "Retail",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: 3499,
    shortDescription:
      "Build a star-schema warehouse from raw sales data and an interactive BI dashboard.",
    description:
      "Create a retail analytics project that ingests transactional data, models it into a star schema, runs analytical SQL queries and serves KPIs through an interactive dashboard.",
    technologies: ["Python", "Pandas", "PostgreSQL", "SQL", "Power BI / Streamlit", "Apache Airflow"],
    skills: ["Dimensional Modelling", "ETL Pipelines", "Advanced SQL", "KPI Design", "Scheduled Jobs", "Dashboard Development"],
    features: ["Raw data ingestion", "Star schema design", "ETL pipeline", "Analytical queries", "KPI dashboard", "Refresh scheduling"],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },
  {
    id: "air-quality-analysis-prediction",
    title: "Air Quality Analysis and AQI Prediction",
    category: "Data Science",
    domain: "Environment",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: 3499,
    shortDescription:
      "Analyse historical air quality data and predict AQI using regression models.",
    description:
      "Build a data science project that ingests AQI datasets, analyses pollutant trends and weather correlation, and forecasts AQI using regression and time-series models, presented on an interactive map.",
    technologies: ["Python", "Pandas", "Scikit-learn", "Plotly", "Folium", "Streamlit"],
    skills: ["Time Series Forecasting", "Regression Modelling", "Correlation Analysis", "Geospatial Visualisation", "Feature Engineering", "Dashboard Development"],
    features: ["Historical AQI analysis", "Pollutant correlation", "AQI forecasting", "City-level maps", "Health advisory logic", "Exportable reports"],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },
  {
    id: "hr-analytics-attrition",
    title: "HR Analytics and Employee Attrition Prediction",
    category: "Data Science",
    domain: "Human Resources",
    difficulty: "Intermediate",
    duration: "6-8 Weeks",
    price: 2499,
    shortDescription:
      "Analyse employee data and predict attrition risk using classification models.",
    description:
      "Develop an HR analytics project that explores employee data, identifies attrition drivers with feature importance and predicts at-risk employees, with recommendations for retention teams.",
    technologies: ["Python", "Pandas", "Scikit-learn", "Seaborn", "Flask", "React"],
    skills: ["Exploratory Data Analysis", "Classification", "Feature Importance", "Model Evaluation", "Data Visualisation", "REST API Development"],
    features: ["Employee dataset upload", "Attrition analysis", "Risk prediction", "Feature importance chart", "Retention recommendations", "HR dashboard"],
    suitableFor: ["BCA", "MCA", "B.Tech", "BE"],
  },
  {
    id: "energy-consumption-forecasting",
    title: "Energy Consumption Forecasting",
    category: "Data Science",
    domain: "Energy",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: 3499,
    shortDescription:
      "Forecast electricity consumption using historical demand and weather data.",
    description:
      "Build a forecasting system that models household or grid energy consumption using seasonal patterns and weather features, comparing ARIMA, Prophet and gradient-boosting models with an interactive dashboard.",
    technologies: ["Python", "Pandas", "Prophet", "Scikit-learn", "Plotly", "Streamlit"],
    skills: ["Time Series Forecasting", "Seasonality Modelling", "Model Comparison", "Feature Engineering", "Data Visualisation", "Dashboard Development"],
    features: ["Historical consumption analysis", "Weather integration", "Multi-model forecasting", "Accuracy comparison", "Interactive charts", "Exportable forecasts"],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },

  /* ================================================================
     GENERATIVE AI  ·  NEW
     ================================================================ */
  {
    id: "ai-chatbot-rag",
    title: "AI Chatbot with RAG over Custom Documents",
    category: "GenAI",
    domain: "Enterprise AI",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: 3999,
    shortDescription:
      "Chat with your own PDFs and documents using retrieval-augmented generation.",
    description:
      "Build a chatbot that ingests user-uploaded PDFs, chunks and embeds them into a vector store, retrieves relevant context and answers questions using an LLM — with citations and conversation memory.",
    technologies: ["Python", "LangChain", "OpenAI / Llama", "FAISS / Pinecone", "FastAPI", "React"],
    skills: ["RAG Architecture", "Document Chunking", "Vector Embeddings", "Prompt Engineering", "LLM API Integration", "REST API Development"],
    features: ["Document upload", "Chunking & embedding", "Semantic search", "Context-aware answers", "Source citations", "Conversation history"],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },
  {
    id: "ai-image-generator",
    title: "AI Image Generator from Text Prompts",
    category: "GenAI",
    domain: "Creative AI",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: 3999,
    shortDescription:
      "Generate images from natural-language prompts using diffusion models.",
    description:
      "Build a text-to-image generator using Stable Diffusion with prompt enhancement, aspect ratio control and style presets, served through a web UI with history and download options.",
    technologies: ["Python", "Stable Diffusion", "Diffusers", "PyTorch", "FastAPI", "React"],
    skills: ["Diffusion Models", "Prompt Engineering", "GPU Inference", "Image Post-processing", "Model Optimisation", "REST API Development"],
    features: ["Prompt input", "Style presets", "Aspect ratio control", "Seed control", "Generation history", "Download in multiple formats"],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },
  {
    id: "ai-content-writer",
    title: "AI Content Writing Assistant",
    category: "GenAI",
    domain: "Marketing & Content",
    difficulty: "Intermediate",
    duration: "6-8 Weeks",
    price: 2999,
    shortDescription:
      "Generate blogs, product descriptions, ad copy and social posts from a short brief.",
    description:
      "Create an AI content assistant that generates long-form blogs, product descriptions and marketing copy with tone control, SEO keyword suggestions and a draft management workspace.",
    technologies: ["Python", "OpenAI API", "LangChain", "FastAPI", "React", "MongoDB"],
    skills: ["Prompt Engineering", "LLM API Integration", "Content Structuring", "SEO Basics", "Streaming Responses", "REST API Development"],
    features: ["Brief input", "Tone & length control", "Blog / ad / social presets", "SEO keyword suggestions", "Draft history", "Export to markdown"],
    suitableFor: ["BCA", "MCA", "B.Tech", "BE"],
  },
  {
    id: "ai-code-review-assistant",
    title: "AI Code Review and Explanation Assistant",
    category: "GenAI",
    domain: "Developer Tools",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: 3999,
    shortDescription:
      "Analyse source code, suggest improvements and explain logic using an LLM.",
    description:
      "Build a code assistant that accepts pasted or uploaded code, detects language automatically, produces line-by-line explanations, suggests fixes and generates unit-test stubs, with a diff-style review UI.",
    technologies: ["Python", "OpenAI / Llama", "LangChain", "FastAPI", "React", "Monaco Editor"],
    skills: ["Code Parsing", "Prompt Engineering", "LLM API Integration", "Diff Generation", "Editor Integration", "REST API Development"],
    features: ["Paste or upload code", "Auto language detection", "Line-by-line explanation", "Fix suggestions with diff", "Unit-test generation", "History"],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },
  {
    id: "ai-voice-assistant",
    title: "AI Voice Assistant with Speech-to-Speech",
    category: "GenAI",
    domain: "Voice AI",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: 3999,
    shortDescription:
      "Talk to an AI assistant that listens, reasons and replies with natural voice.",
    description:
      "Develop a voice assistant that converts speech to text, processes the query with an LLM, and returns a spoken reply using text-to-speech — with wake-word support and conversation memory.",
    technologies: ["Python", "Whisper", "OpenAI / Llama", "ElevenLabs / Coqui TTS", "FastAPI", "React"],
    skills: ["Speech-to-Text", "Text-to-Speech", "LLM Integration", "Streaming Audio", "Wake-Word Detection", "REST API Development"],
    features: ["Speech input", "Transcription", "LLM reasoning", "Voice reply", "Conversation memory", "Voice selection"],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },
  {
    id: "ai-resume-builder",
    title: "AI Resume and Cover Letter Builder",
    category: "GenAI",
    domain: "Career Technology",
    difficulty: "Intermediate",
    duration: "6-8 Weeks",
    price: 2999,
    shortDescription:
      "Generate tailored resumes and cover letters from a short career brief using an LLM.",
    description:
      "Build an AI resume builder that takes a user's career summary and a target job description, and produces ATS-friendly resume content and a matching cover letter — with PDF export and version history.",
    technologies: ["Python", "OpenAI API", "FastAPI", "React", "Puppeteer", "MongoDB"],
    skills: ["Prompt Engineering", "LLM API Integration", "PDF Generation", "Version Management", "ATS Principles", "REST API Development"],
    features: ["Career brief input", "Job description matching", "Resume generation", "Cover letter generation", "PDF export", "Version history"],
    suitableFor: ["BCA", "MCA", "B.Tech", "BE"],
  },
  {
    id: "ai-meeting-summarizer",
    title: "AI Meeting Summarizer and Action Extractor",
    category: "GenAI",
    domain: "Productivity",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: 3499,
    shortDescription:
      "Transcribe meeting audio and generate summaries with assigned action items.",
    description:
      "Build a meeting intelligence tool that transcribes uploaded audio with Whisper, identifies speakers, summarises key points and extracts action items with owners and deadlines.",
    technologies: ["Python", "Whisper", "OpenAI / Llama", "FastAPI", "React", "MongoDB"],
    skills: ["Audio Transcription", "Speaker Diarisation", "Summarisation", "Information Extraction", "LLM Integration", "REST API Development"],
    features: ["Audio upload", "Transcription", "Speaker labelling", "Meeting summary", "Action item extraction", "Searchable transcript"],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },
  {
    id: "ai-tutor-personalised-learning",
    title: "AI Tutor for Personalised Learning",
    category: "GenAI",
    domain: "Education",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: 3999,
    shortDescription:
      "A tutor chatbot that adapts explanations and quizzes to the learner's level.",
    description:
      "Develop an AI tutoring platform that assesses a learner's current level, explains topics with adaptive depth, generates practice questions and tracks mastery across subjects.",
    technologies: ["Python", "OpenAI / Llama", "LangChain", "FastAPI", "React", "PostgreSQL"],
    skills: ["Adaptive Learning Logic", "Prompt Engineering", "Quiz Generation", "Progress Tracking", "LLM Integration", "REST API Development"],
    features: ["Level assessment", "Adaptive explanations", "Generated quizzes", "Instant feedback", "Mastery tracking", "Subject-wise dashboards"],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },
];

export default projects;